import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';

const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState<T>(value);

  const setDebouncedFn = useMemo(() => debounce(setDebounced, delayMs), [delayMs]);

  useEffect(() => {
    setDebouncedFn(value);

    return () => setDebouncedFn.cancel();
  }, [value, setDebouncedFn]);

  return debounced;
};

export default useDebouncedValue;
